// @flow
import { connect } from 'react-redux';
import type { StateProps } from './BillingAddress';
import BillingAddress from './BillingAddress';
import { billingAddressSelector } from '../../modules/Customer/selectors';

const mapStateToProps = (state): StateProps => {
  const { street1, street2, postCode, city } = billingAddressSelector(state);
  return {
    street1,
    street2,
    postCode,
    city,
  };
};

export default connect(mapStateToProps)(BillingAddress);
